import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSessionContext } from '@/features/auth';

interface GuestRouteProps {
	children?: React.ReactNode;
}

const GuestRoute: React.FC<GuestRouteProps> = ({ children }) => {
	const { isAuthenticated } = useSessionContext();
	const location = useLocation();
	const from = location.state?.from?.pathname || '/home';

	if (isAuthenticated) {
		return (
			<Navigate
				to={from}
				replace
			/>
		);
	}

	if (children) {
		return <>{children}</>;
	}

	return <Outlet />;
};

export default GuestRoute;
